export const clueStepDefault = {
  clueType: '',
  clueOrder: 0,
  clueName: '',
  startDate: '',
  description: '',
  longitude: undefined,
  latitude: undefined,
  expiryDate: '',
  clueReward: '',
  maxClaims: '',
  hotLv: 0,
};

export const clueTenStepDefault = [
  {
    ...clueStepDefault,
    name: 'Starter Clue',
  },
  {
    ...clueStepDefault,
    name: 'Clue 2',
  },
  {
    ...clueStepDefault,
    name: 'Clue 3',
  },
  {
    ...clueStepDefault,
    name: 'Clue 4',
  },
  {
    ...clueStepDefault,
    name: 'Clue 5',
  },
  {
    ...clueStepDefault,
    name: 'Clue 6',
  },
  {
    ...clueStepDefault,
    name: 'Clue 7',
  },
  {
    ...clueStepDefault,
    name: 'Clue 8',
  },
  {
    ...clueStepDefault,
    name: 'Clue 9',
  },
  {
    ...clueStepDefault,
    name: 'Clue 10',
  },
];

export const defaultClueQueryLimit = 50;
export const cluesCache = 150;
export const getClueDebounceTime = 200;
export const requiredCoordinates = ['north', 'west', 'south', 'east', 'zoom'];

export const UserClueStatusEnum = {
  Live: 'live',
  Soon: 'soon',
  Ongoing: 'ongoing',
  Finished: 'finished',
  Found: 'found',
};
export const statusClasses = {
  draft: 'bg-yellow-100 text-yellow-700',
  live: 'bg-green-100 text-green-700',
  paused: 'bg-blue-100 text-blue-700',
  done: 'bg-gray-100 text-gray-700',
};
export const defaultZoom = 15;
export const initialQrForm = 'IGC Free Coffee'

export const defaultQrFields = ['typeMarket', 'clueName', 'description', 'clueReward','address', 'latitude', 'longitude']